import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';

import { PropsFromRedux } from '.';

interface Props extends PropsFromRedux {}

const FraudNotificationModal: React.FC<PropsFromRedux> = ({ hideModal }) => (
  <div className="relative w-full px-2 py-10 bg-white lg:px-20">
    <button
      type="button"
      aria-label="Close"
      onClick={hideModal}
      className="absolute z-50 text-2xl text-gray-700 top-4 right-4 hover:text-black"
    >
      <IoCloseSharp className="cursor-pointer" />
    </button>
    <div className="mb-3 text-center">
      <h2 className="text-lg font-semibold">Security Alert</h2>
    </div>

    <div className="w-full my-6 text-center">
      <p className="my-3 text-sm text-gray-700">
        Please beware of fraudulent messages. Only trust communications from our
        official channels and do not share your personal information with
        unknown sources.
      </p>
      <p className="text-sm text-gray-700">
        Never make payments to any personal or staff bank accounts. Always
        ensure you’re paying directly into an official GIG Logistics bank
        account.
      </p>
    </div>

    <div className="justify-end d-flex">
      <button
        className="w-full py-3 text-sm font-medium text-white rounded bg-secondary"
        type="button"
        onClick={hideModal}
      >
        I Understand
      </button>
    </div>
  </div>
);

export default FraudNotificationModal;
